hljs.registerLanguage("redbol",(()=>{"use strict";return e=>{var a={
className:"string",begin:"\\^(\\(([0-9a-fA-F]+|del)\\)|.)"};return{
aliases:["rebol","red","red/system"],keywords:{
lexemes:"[a-zA-Z_][a-zA-Z0-9_\\-\\!]*",
keyword:"make set print probe|10 func function does has do while until unless|10 if either|10 else for foreach|10 forall|10 forskip|10 remove-each until while case loop repeat|10 switch at insert append tail head back repend next to thru collect keep return throw catch continue break open close load reduce|10 rejoin|10 insert bind parse|10 union intersect unique charset extend object context",
literal:"off on yes no true false null none not all any end integer!",
built_in:"random absolute add divide multiply negate remainder subtract pick reverse select find"
},illegal:/(\/\*|\/\/)/,contains:[{className:"string",illegal:"\\n",variants:[{
begin:'"',end:'"'},{begin:'%"',end:'"'}],contains:[a]},{className:"string",
begin:"{",end:"}",contains:[a]},{className:"string",
begin:"%[^\\s\\n\\[\\]\\(\\)]+"},{className:"string",
begin:"[A-Za-z][\\w]{1,9}:(/{0,3}[^\\s\\n\\[\\]\\(\\)]+|//)"},{
className:"string",begin:"<",end:">",illegal:"\\n"},{className:"string",
begin:"[^\\s\\n:/\\[\\]\\(\\)]+@[^\\s\\n:/\\[\\]\\(\\)]+"},{
className:"variable",begin:"/[^\\s\\n\\[\\]\\(\\)]*"},{className:"literal",
begin:/[a-zA-Z]+[a-zA-Z0-9_\-\!]*\!/},{className:"literal",
begin:/\'[a-zA-Z_]+[a-zA-Z0-9_\-\!]*/},{className:"string",
begin:"2#\\{(([01]\\s*){8})*\\}"},{className:"string",
begin:"(16)?#\\{\\s*([0-9a-fA-F]{2,2}\\s*)*\\}"},{className:"string",
begin:"64#\\{[0-9a-zA-Z+/=\\s]*\\}"},{className:"doctag",begin:";-.*",
illegal:"\\n"},{className:"comment",begin:";.*",illegal:"\\n"},{
className:"comment",begin:"\\s: ",end:"\\n"},{className:"doctag",
begin:/^(>>|red>>)/},{className:"doctag",begin:/^[\*]{2}[\*]*\s/,end:/\n/},{
className:"number",begin:/[-+]?\d+x[-+]?\d+/},{className:"number",
begin:"\\d{1,2}\\-([A-Za-z]{3}|January|Febuary|March|April|May|June|July|August|September|October|November|December)\\-\\d{4}(/\\d{1,2}[:]\\d{1,2}([:]\\d{1,2}(\\.\\d{1,5})?)?([+-]\\d{1,2}[:]\\d{1,2})?)?"
},{className:"number",
begin:/([-+]?[:]\d{1,2}([aApP][mM])?)|([-+]?[:]\d{1,2}[.]\d{0,9})|([-+]?\d{1,2}[:]\\d{1,2}([aApP][mM])?)|([-+]?\d{1,2}[:]\d{1,2}[.]\d{0,9})|([-+]?\d{1,2}[:]\d{1,2}[:]\d{1,2}([.]\d{0,9})?([aApP][mM])?)(?!\w)/
},{className:"number",begin:"(\\d{0,3}[.]\\d{0,3}[.]\\d{0,3}([.]\\d{0,3}){0,7})"
},{className:"built_in",
begin:/(\s|\t)+(==|!=|<=|>=|<>|<|>|>>|>>>|<<|\+|-|=|\*|%|\/|\b(and|or|xor))(?=\s|\(|\[|\)|\]|\/|;|\"|{|$)/
},{className:"section",begin:/[a-zA-Z_\-]+[a-zA-Z0-9_\-]*:/},{
className:"section",begin:/:[a-zA-Z_\-]+[a-zA-Z0-9_\-]*/},{className:"regexp",
begin:/(\[|\]|\(|\))+|\#\(|\#\[/},{className:"string",
begin:/\#[^\s\n\[\]\(\)\/]*/},{className:"number",
begin:'([0-9A-F]+)h(?=\\s|\\)|\\]|/|;|\\"|{\\[|\\(|$)'},{className:"number",
begin:"-?[a-zA-Z]*\\$\\d+(\\.\\d*)?"},e.C_NUMBER_MODE]}}})());